"use client";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { ScrollArea } from "@/components/ui/scroll-area";
import UserInfo from "./user-info";
import ColorMode from "./color-mode";

let QuranDrawer = ({
  title,
  children,
  drawerOpen,
  closeDrawer,
}: {
  title?: string;
  children?: React.ReactNode;
  drawerOpen: boolean;
  closeDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Drawer open={drawerOpen} onOpenChange={closeDrawer} direction="right">
      <DrawerContent
        showOverlay
        className="h-screen border-0 top-0 right-0 left-auto mt-0 w-5/6 sm:w-[400px] rounded-none rounded-bl-lg rounded-tl-lg"
      >
        <div className="bg-primary/10 h-full">
          <ScrollArea>
            <div className="w-full  h-full">
              <DrawerHeader>
                <DrawerTitle className="flex flex-row w-full justify-between items-center">
                  <UserInfo />
                </DrawerTitle>
              </DrawerHeader>
              <div className="p-4 pb-0 pt-0 space-y-4">
                <ColorMode />
                <div className={"w-full flex flex-col h-[calc(100vh-17em)]"}>
                  {children}
                </div>
              </div>
            </div>
          </ScrollArea>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default QuranDrawer;
